import { WatchlistSummary, watchlistSummary } from '@api/api/watchlist-summary';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const QUERY_KEY_WATCHLIST_SUMMARY = 'QUERY_KEY_WATCHLIST_SUMMARY';

interface ApiError extends Error {
  status: number;
}

export const useWatchlistSummary = (watchlistId: string) =>
  useQuery<WatchlistSummary, ApiError>({
    queryKey: [QUERY_KEY_WATCHLIST_SUMMARY, watchlistId],
    queryFn: ({ signal }) =>
      wretchRequest<WatchlistSummary>(
        watchlistSummary.getWatchlistSummary.path(watchlistId),
        {
          schema: watchlistSummary.getWatchlistSummary.schema,
          signal,
        }
      ),
    staleTime: getTimeTillEndOfDayMs(),
  });
